import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import { restActionFactory } from "../../toolkit/axiosActions/axiosActionsFactory";
import { deleteEmptyProps } from "../../toolkit/utils/filter-utils";

const EXTERNOS_BASE_URL = "/api/externos";

// Construye una instancia de RestAction para Redux, para manipular ExternoDetalle
const externoDetalleRestAction = restActionFactory(
  `${constants.BASE_URL}${EXTERNOS_BASE_URL}`
);

export const clearExternosDetalle = (): IAction => ({
  type: actionTypes.CLEAR_EXTERNOS_DETALLE,
  payload: true
});

export const getExternoDetalleByIdPersona = (
  idPersona: number,
  params?: any
): IAction => {
  return externoDetalleRestAction({
    actionType: actionTypes.GET_EXTERNO_DETALLE_BY_ID_PERSONA,
    urlComplement: `/${idPersona}/detalle/individual`,
    method: "get",
    params: deleteEmptyProps(params || {})
  });
};

export const getExternosDetalleByIdPersona = (
  idPersona: number,
  params?: any
): IAction => {
  return externoDetalleRestAction({
    actionType: actionTypes.GET_EXTERNOS_DETALLE_BY_ID_PERSONA,
    urlComplement: `/${idPersona}/detalle`,
    method: "get",
    params: deleteEmptyProps(params || {})
  });
};

export const getExternosDetalleByCurp = (
  curp: string,
  params?: { paramCurp?: string; [k: string]: any }
): IAction => {
  return externoDetalleRestAction({
    actionType: actionTypes.GET_EXTERNOS_DETALLE_BY_CURP,
    urlComplement: `/curps/${encodeURIComponent(curp)}/detalle`,
    method: "get",
    params: deleteEmptyProps(params || {})
  });
};

export const getExternosDetalleByFilters = (params?: {
  nombre?: string;
  paramNombre?: string;
  fechaNacimiento?: string;
  [k: string]: any;
}): IAction => {
  return externoDetalleRestAction({
    actionType: actionTypes.GET_EXTERNOS_DETALLE_BY_FILTERS,
    urlComplement: `/detalle/by-filters`,
    method: "get",
    params: deleteEmptyProps(params || {})
  });
};
